// MessageCategoryTabContent.js
'use strict';
'use client';
import { connect } from 'react-redux';

import MessageCategoryTabContent from '../component/MessageCategoryTabContent.jsx';

import getListData from '../selector/getListData.js';
import getNetworkingData from '../selector/getNetworkingData.js';
import { getSelectedQueryOptionObject } from '../selector/getFeedQueryObject.js';
import getSelectedFeedQueryOptions from '../selector/getSelectedFeedQueryOptions.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';

import { getReturnType } from '../action/fetchFeeds.js';

import { CATEGORY_FEED_REMOTE_CONFIG_KEYS } from '../resource/categoryConstants.js';
import { QueryPrefix, QueryType } from '../resource/feedConstants.js';

import { MESSAGE_CATEGORY_TABS } from '../RemoteConfigKeys.js';

const mapStateToProps = (
  state,
  { match, categoryId: propsCategoryId, listType: propsListType }
) => {
  const categoryTabs = getRemoteConfigData(state, MESSAGE_CATEGORY_TABS);
  const categoryId = propsCategoryId || match?.params?.categoryId;
  const listType =
    propsListType || match?.params?.listType || categoryTabs?.[0];
  const feedNameRemoteConfigKey = CATEGORY_FEED_REMOTE_CONFIG_KEYS[listType];
  const categoryFeedName = getRemoteConfigData(
    state,
    feedNameRemoteConfigKey,
    undefined,
    {
      CATEGORY: categoryId,
    }
  );
  const sortingsRemoteConfigKey = `${feedNameRemoteConfigKey}_${
    QueryPrefix[QueryType.SORT]
  }`;
  const { feedNameWithQuery } = getSelectedQueryOptionObject(
    state,
    categoryFeedName,
    getSelectedFeedQueryOptions(state, feedNameRemoteConfigKey, undefined),
    getRemoteConfigData(state, sortingsRemoteConfigKey)?.[0]
  );
  const listSelectPath = [
    'home',
    getReturnType({ feedName: feedNameWithQuery }),
    feedNameWithQuery,
  ];
  const postIds = getListData(state, listSelectPath, 'itemIds');
  const isFirstPageFetched = getNetworkingData(
    state,
    [...listSelectPath, 1],
    'isFetched'
  );
  return {
    categoryId,
    listType,
    categoryFeedName,
    feedNameWithQuery,
    feedNameRemoteConfigKey,
    isFirstPageFetched,
    listSelectPath,
    postIds,
  };
};

export default connect(mapStateToProps)(MessageCategoryTabContent);
